import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Cookies from 'js-cookie'

import { FormControl, Checkbox, TextField, Grid, Tooltip, Dialog, DialogTitle, DialogActions, IconButton, DialogContent, Box, FormControlLabel, Card, CardContent, Typography, CardActions, Button } from '@mui/material/';

import Autorize from '../../components/ui/autorize';
import { GridRowModes, DataGrid, GridToolbarContainer, GridActionsCellItem, GridRowEditStopReasons, } from '@mui/x-data-grid';
import { getSessionValide, getUserRule, getIsAdmin } from '../../utils/userRule';



export default function FullFeaturedCrudGrid() {

    // const [rows, setRows] = React.useState();
    const [rowModesModel, setRowModesModel] = useState({});
    const [autorize, setAutorize] = useState("false");
    const [editEnabled, setEditEnabled] = useState(false);
    const [errorAxios, setErrorAxios] = useState("false");
    const [dialogOpen, setDialogOpen] = useState(false);
    const [selectedUser, setSelectedUser] = useState({});
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [reloadVar, setReloadVar] = useState(false);


    const [listUser, setListUser] = useState([]);

    const MyAxios = axios.create({
        headers: {
            Authorization: "Bearer " + Cookies.get('token'),
        }
    })

    useEffect(() => {


        const fetchData = async () => {
            try {

                let RuleReport = await getIsAdmin();

                setAutorize(RuleReport);

            } catch (error) {
                console.error('Une erreur s\'est produite lors de la récupération des données', error);
            }
        };
        fetchData();


        if (autorize) {
            setReloadVar(false);

            //, { headers: { Authorization: "Bearer "+ cookies }}
            MyAxios.get(process.env.REACT_APP_API + '/utilisateurs/getAllUsers') //axios.defaults.withCredentials = true
                .then((res) => {

                    setErrorAxios(false);
                    // console.log(res);
                    setListUser(res.data);
                    //setRowModesModel(res.data);

                })
                .catch((error) => {
                    console.log(error)
                    ///  if(error.status)  
                    if (error.response.status === 401)// pas autorisé
                        setErrorAxios(true);

                });
        }

    }, [autorize, reloadVar]);



    const handleSauvegarde = () => () => {

        //, { headers: { Authorization: "Bearer "+ cookies }}
        MyAxios.post(process.env.REACT_APP_API + '/utilisateurs/setUserAdd', selectedUser) //axios.defaults.withCredentials = true
            .then((res) => {
                setReloadVar(true);
                alert("Sauvegarde complété");
                console.log(res.data);
                setDialogOpen(false);

            })
            .catch((error) => {
                console.log(error)
                ///  if(error.status)  
                if (error.response.status === 401)// pas autorisé
                    setErrorAxios(true);

            });


    };




    function closeModal() {
        setDialogOpen(false);
    }


    const editUser = (id) => {
        const user = listUser.find(user => user.id === id);
        setSelectedUser(user);
        setDialogOpen(true);
    };


    const newUser = () => {
        const newOne = {
            id: "new",
            email  : "",
            users_desc  : "",
            user_nom_reel: "",
            read_reports : 0,
            read_all_club  : 0,
            write_all_club : 0, 
            read_own_club  : 0,
            write_own_club  : 0,
            read_member  : 0,
            write_member  : 0,
            read_own_secteur: 0,  
            create_club  : 0,    
        }
        setSelectedUser(newOne);
        setDialogOpen(true);
    };


    const handleDeleteClick = (id) => {
        const user = listUser.find(user => user.id === id);
        setSelectedUser(user);
        setConfirmDialogOpen(true);
    };

    const handleCancelDelete = () => {
        // Annuler la suppression, ferme le dialogue de confirmation
        setConfirmDialogOpen(false);
    };


    const handleConfirmDelete = () => {


        MyAxios.post(process.env.REACT_APP_API + '/utilisateurs/deleteUser', selectedUser) //axios.defaults.withCredentials = true
            .then((res) => {
                setReloadVar(true);
                alert("Sauvegarde complété");
                console.log(res.data);
                setDialogOpen(false);

            })
            .catch((error) => {
                console.log(error)
                ///  if(error.status)  
                if (error.response.status === 401)// pas autorisé
                    setErrorAxios(true);

            });



        setConfirmDialogOpen(false);
    };


    //  onChange={handleChange}
    return (
        <div>

            <Button onClick={() => newUser()} variant="outlined">Ajouter une nouvelle personne</Button>
            <hr />

            <Box>
                {/* En-têtes de colonnes */}
                <Grid container>
                    <Grid item xs={2}>Email Description Nom</Grid>
                    <Grid item xs={1}>Lecture des rapports</Grid>
                    <Grid item xs={1}>Lecture tous les clubs</Grid>
                    <Grid item xs={1}>Ecriture tous les clubs</Grid>
                    <Grid item xs={1}>Lecture son propre club</Grid>
                    <Grid item xs={1}>Ecriture son propre club</Grid>
                    <Grid item xs={1}>Lecture des membres</Grid>
                    <Grid item xs={1}>Ecriture des membres</Grid>
                    <Grid item xs={1}>Lecture propre secteur</Grid>
                    <Grid item xs={1}>Création club ADMIN</Grid>
                    <Grid item xs={1}>Action</Grid>
                </Grid>
                <hr />
                {/* Données de la grille avec des cases à cocher */}
                {listUser.map((user, index) => (
                    <Grid key={index} container>
                        <Grid item xs={2}>{user.email}  <br />{user.users_desc} <br /> {user.user_nom_reel}</Grid>

                        <Grid item xs={1}>
                            <Checkbox disabled checked={user.read_reports === 1} />
                        </Grid>
                        <Grid item xs={1}>

                            <Checkbox disabled checked={user.read_all_club === 1} />


                        </Grid>
                        <Grid item xs={1}>

                            <Checkbox disabled checked={user.write_all_club === 1} />

                        </Grid>
                        <Grid item xs={1}>

                            <Checkbox disabled checked={user.read_own_club === 1} />

                        </Grid>
                        <Grid item xs={1}>

                            <Checkbox disabled checked={user.write_own_club === 1} />

                        </Grid>
                        <Grid item xs={1}>

                            <Checkbox disabled checked={user.read_member === 1} />

                        </Grid>
                        <Grid item xs={1}>

                            <Checkbox disabled checked={user.write_member === 1} />

                        </Grid>
                        <Grid item xs={1}>

                            <Checkbox disabled checked={user.read_own_secteur === 1} />

                        </Grid>
                        <Grid item xs={1}>

                            <Checkbox disabled checked={user.create_club === 1} />

                        </Grid>
                        <Grid item xs={1}>
                        { user.id >= 3 ?<>
                            <Button onClick={() => editUser(user.id)} variant="outlined">Edit</Button>
                            <Button onClick={() => handleDeleteClick(user.id)} variant="outlined">Delete</Button>
                             </> : null }
                        </Grid>
                        <Grid item xs={12}>
                            <hr />
                        </Grid>
                    </Grid>

                ))}
            </Box>



            <Dialog key="DialogEditUser"
                fullWidth
                maxWidth="xl"
                open={dialogOpen}
            >
                <DialogTitle>Utilisateur</DialogTitle>
                <DialogContent dividers>



                    <Grid container m={2} p={2}>

                        <Grid item m={2} xs={3}>
                            <TextField id="Courriel"
                                value={selectedUser ? selectedUser.email : ''}
                                onChange={(event) => setSelectedUser({ ...selectedUser, email: event.target.value })}
                                label="Courriel" fullWidth
                            />
                        </Grid>
                        <Grid item m={2} xs={3}>
                            <TextField id="Description"
                                value={selectedUser ? selectedUser.users_desc : ''}
                                onChange={(event) => setSelectedUser({ ...selectedUser, users_desc: event.target.value })}
                                label="Description" fullWidth />
                        </Grid>
                        <Grid item m={2} xs={3}>

                            <TextField id="Nomreel"
                                value={selectedUser ? selectedUser.user_nom_reel : ''}
                                onChange={(event) => setSelectedUser({ ...selectedUser, user_nom_reel: event.target.value })}
                                label="Nom réel" fullWidth />


                        </Grid>
                    </Grid>


                    <Grid container>
                        <Grid item xs={1}>Lecture des rapports</Grid>
                        <Grid item xs={1}>Lecture tous les clubs</Grid>
                        <Grid item xs={1}>Ecriture tous les clubs</Grid>
                        <Grid item xs={1}>Lecture son propre club</Grid>
                        <Grid item xs={1}>Ecriture son propre club</Grid>
                        <Grid item xs={1}>Lecture des membres</Grid>
                        <Grid item xs={1}>Ecriture des membres</Grid>
                        <Grid item xs={1}>Lecture propre secteur</Grid>
                        <Grid item xs={1}>Création club ADMIN</Grid>
                    </Grid>

                    {/* Données de la grille avec des cases à cocher */}

                    <Grid container>


                        <Grid item xs={1}>
                            <Checkbox
                                checked={selectedUser ? selectedUser.read_reports === 1 : false}
                                onChange={(event) => setSelectedUser({ ...selectedUser, read_reports: event.target.checked ? 1 : 0 })}
                            />
                        </Grid>
                        <Grid item xs={1}>
                            <Checkbox
                                checked={selectedUser ? selectedUser.read_all_club === 1 : false}
                                onChange={(event) => setSelectedUser({ ...selectedUser, read_all_club: event.target.checked ? 1 : 0 })}
                            />
                        </Grid>
                        <Grid item xs={1}>
                            <Checkbox
                                checked={selectedUser ? selectedUser.write_all_club === 1 : false}
                                onChange={(event) => setSelectedUser({ ...selectedUser, write_all_club: event.target.checked ? 1 : 0 })}
                            />
                        </Grid>
                        <Grid item xs={1}>
                            <Checkbox
                                checked={selectedUser ? selectedUser.read_own_club === 1 : false}
                                onChange={(event) => setSelectedUser({ ...selectedUser, read_own_club: event.target.checked ? 1 : 0 })}
                            />
                        </Grid>
                        <Grid item xs={1}>
                            <Checkbox
                                checked={selectedUser ? selectedUser.write_own_club === 1 : false}
                                onChange={(event) => setSelectedUser({ ...selectedUser, write_own_club: event.target.checked ? 1 : 0 })}
                            />
                        </Grid>
                        <Grid item xs={1}>
                            <Checkbox
                                checked={selectedUser ? selectedUser.read_member === 1 : false}
                                onChange={(event) => setSelectedUser({ ...selectedUser, read_member: event.target.checked ? 1 : 0 })}
                            />
                        </Grid>
                        <Grid item xs={1}>
                            <Checkbox
                                checked={selectedUser ? selectedUser.write_member === 1 : false}
                                onChange={(event) => setSelectedUser({ ...selectedUser, write_member: event.target.checked ? 1 : 0 })}
                            />
                        </Grid>
                        <Grid item xs={1}>
                            <Checkbox
                                checked={selectedUser ? selectedUser.read_own_secteur === 1 : false}
                                onChange={(event) => setSelectedUser({ ...selectedUser, read_own_secteur: event.target.checked ? 1 : 0 })}
                            />
                        </Grid>
                        <Grid item xs={1}>
                            <Checkbox
                                checked={selectedUser ? selectedUser.create_club === 1 : false}
                                onChange={(event) => setSelectedUser({ ...selectedUser, create_club: event.target.checked ? 1 : 0 })}
                            />
                        </Grid>
                    </Grid>

                </ DialogContent>


                <DialogActions>
                    <Button onClick={handleSauvegarde()} variant="containedFifth" color="primary">Sauvegarder</Button>
                    <Button onClick={handleCancelDelete} variant="outlined">Annuler</Button>
                    <Button onClick={closeModal}>Fermer
                    </Button>
                </DialogActions>
            </Dialog>




            {/* Dialogue de confirmation */}
            <Dialog open={confirmDialogOpen} onClose={handleCancelDelete}>
                <DialogTitle>Confirmer la suppression</DialogTitle>
                <DialogContent>
                    <p>Êtes-vous sûr de vouloir supprimer cet utilisateur ?</p>
                    <p>{selectedUser.user_nom_reel}</p>
                </DialogContent>

                <DialogActions>
                    <Button onClick={() => handleConfirmDelete()} variant="containedFifth" color="primary">Confirmer</Button>
                    <Button onClick={handleCancelDelete} variant="outlined">Annuler</Button>
                </DialogActions>
            </Dialog>


        </div>

    );
}